export default __webpack_public_path__ + "static/media/RDProgram_english.8b93e873.png";